import "./Banner.css";

function Banner({
  backgroundImage,
  label,
  heading,
  heading2,
  text,
  responsive,
  buttons = [],
}) {
  return (<>
    <section
      className={responsive ? "banner" : " banner banner-section"}
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="banner-overlay">
        <div className="banner-content">
          {label && <p className="banner-label">{label}</p>}
          {heading && (
            <h1 className="banner-title-text">
              {heading} <span className="title-blue ">{heading2}</span>
            </h1>
          )}
          {text && <p className="banner-description">{text}</p>}

          {buttons.length > 0 && (
            <div className="banner-buttons">
              {buttons.map((btn, index) =>
                btn.link ? (
                  <a
                    key={index}
                    href={btn.link}
                    className={
                      index === 0
                        ? "banner-btn-link"
                        : "banner-btn-gradient-border"
                    }
                  >
                    <button
                      type="button"
                      className={`banner-btn ${index === 0
                          ? "banner-btn-primary"
                          : "banner-btn-secondary"
                        }`}
                      onClick={btn.onClick}
                    >
                      {btn.text}

                      {index === 1 && (
                        <img
                          src="/assets/arrow.svg"
                          alt="arrow"
                          className="btn-arrow"
                        />
                      )}
                    </button>
                  </a>
                ) : (
                  <div
                    key={index}
                    className={
                      index === 0
                        ? "banner-btn-link"
                        : "banner-btn-gradient-border"
                    }
                  >
                    <button
                      type="button"
                      className={`banner-btn ${index === 0
                          ? "banner-btn-primary"
                          : "banner-btn-secondary"
                        }`}
                      onClick={btn.onClick}
                    >
                      {btn.text}

                      {index === 1 && (
                        <img
                          src="/assets/arrow.svg"
                          alt="arrow"
                          className="btn-arrow"
                        />
                      )}
                    </button>
                  </div>
                )
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  </>);
}

export default Banner;
